import providerId from 'modules/bus/shared/selectors/userConfig/busProviderId';
import convertDateToMDY from 'common/utils/date/convertDateToMDY';
import convertDateToHM from 'common/utils/date/convertDateToHM';

export default function searchSpecSelector(state, goShow = false) {
  const searchFormState = state.bus.bookingSearchForm;
  const agentId = searchFormState.bookOnBehalf
    ? searchFormState.agentId
    : state.bus.userConfig.userId;

  return {
    goShow,
    originCode: searchFormState.origin.code,
    destinationCode: searchFormState.destination.code,
    departureDate: convertDateToMDY(searchFormState.departureDate),
    departureTime: goShow
      ? convertDateToHM(searchFormState.departureDate)
      : { hour: 0, minute: 0 },
    providerId: providerId(state),
    agentId,
  };
}
